const avatar = (avatar, name, width = 80, height = 80) => {
  const randomColor = defaultAvatarColors[(Math.floor(Math.random() * defaultAvatarColors.length))];
    const photo = avatar ? `<img class="rounded" src="${avatar}" width="${width}" height="${height}" />` : `<div class="default-avatar d-flex align-items-center justify-content-center fs-1 tourney ${randomColor} text-uppercase rounded-circle" style="width: ${width}px; height: ${height}px;">${name.split('')[0]}</div>`;

    return photo;
}

export default avatar;


